import React, { useEffect, useState } from "react";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import useApi from "../../../core/customhook/useApi";
import { Calendar } from "primereact/calendar";
import Loader from "../../../core/common/selfLoder";
import { getFinancialYearList } from "../../../core/common/financialYear";

const LeaveBalance = () => {
  const tableStyle: React.CSSProperties = {
    // border: "1px solid #F89520",
    padding: "30px 13px",
    textAlign: "center",
    fontWeight: "500",
  };

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getCurrentFinancialYear = () => {
    const currentYear = new Date().getFullYear(); // e.g., 2025
    const nextYearShort = (currentYear + 1).toString().slice(-2); // "26"
    return `${currentYear}-${nextYearShort}`;
  };

  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

  const leaveTypeAbbreviations: Record<string, string> = {
    "Earned Leave": "EL",
    "Sick Leave": "SL",
    "Restricted Holiday": "RH",
    "Maternity Leave": "ML",
    "Leave Without Pay": "LWP",
    "Short Leave": "SHL",
    "Bereavement Leave": "BL",
    "Wedding Leave": "WL",
    "Half-Day Leave": "HDL",
    "Happiness Leave": "HL",
  };

  const {
    data: leave_Balance_data,
    loading: leave_balamce_loading,
    error: leave_balance_error,
  } = useApi("/api/view-leave-balance", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year],
  });

  const transformLeaveData = (data: any[]) => {
    return data.map((item) => ({
      type: leaveTypeAbbreviations[item.leave_type] || item.leave_type,
      lapse: 0,
      opening: item.opening_balance || 0,
      consumed: item.opening_balance - item.current_balance || 0,
      balance: item.current_balance || 0,
      annual: item.entitlement_balance || 0,
      prorata: item.prorata_balance || 0,
      availed: item.availed_balance || 0,
      available: item.current_balance || 0,
      closing: item.closing_balance || 0,
      applied: item.applied_leaves || 0,
    }));
  };

  console.log(leave_Balance_data , "leave_Balance_data")

  // Category colors (light → dark shades per group)
  const categoryColors = {
    lapse: "#f5f5f5",
    opening: "#f5f5f5",
    consumed: "#e3f2fd",
    balance: "#e3f2fd",
    annual: "#bbdefb",
    prorata: "#bbdefb",
    availed: "#90caf9",
    available: "#90caf9",
    closing: "#1976d2",
    applied: "#0d47a1",
  };

  const leaveTypeMap: Record<string, string> = {
    RH: "Restricted Holiday",
    SL: "Sick Leave",
    EL: "Earned Leave",
    ML: "Maternity Leave",
    LWP: "Leave Without Pay",
    SHL: "Short Leave",
    BL: "Bereavement Leave",
    WL: "Wedding Leave",
    HL: "Hospitalization Leave",
  };

  // Mapping leave type codes to full forms
  const leaveTypeFullForms: Record<string, string> = {
    RH: "Restricted Holiday",
    SL: "Sick Leave",
    EL: "Earned Leave",
    ML: "Maternity Leave",
    LWP: "Leave Without Pay",
    BL: "Bereavement Leave",
    WL: "Wedding Leave",
    HL: "Hospitalization Leave",
    SHL: "Short Leave",
  };

  return (
    <>
      <Loader loading={leave_balamce_loading} />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-2">
            <div className="my-auto mb-2">
              <h2 className="mb-2">Leave Balance</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">Leave</li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.seflGrid}>Self Leave</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Leave Balance
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>
              <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>

                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {getFinancialYearList().map((fy) => (
                    <option key={fy} value={fy}>
                      {fy.split("-")[0]}
                    </option>
                  ))}
                </select>
              </div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>

          {/* Static Leave Table */}
          <div className="card">
            <div className="card-body">
              {/* 🔹 Top Summary Cards */}
              <div className="row mb-3">
                <div className="col-md-4 mb-3">
                  <div
                    className="p-3 rounded d-flex align-items-center justify-content-between"
                    style={{ background: "#e3f2fd" }}
                  >
                    <div>
                      <h6 className="mb-1">Total Available Leaves</h6>
                      <h4 className="mb-0 text-primary">
                        {leave_Balance_data?.AvailableLeaves || 0} Days
                      </h4>
                    </div>
                    <i className="ti ti-calendar-event fs-2 text-primary"></i>
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <div
                    className="p-3 rounded d-flex align-items-center justify-content-between"
                    style={{ background: "#e8f5e9" }}
                  >
                    <div>
                      <h6 className="mb-1">Leaves Used (YTD)</h6>
                      <h4 className="mb-0 text-primary">
                        {leave_Balance_data?.LeavesUsed || 0} Days
                      </h4>
                    </div>
                    <i className="ti ti-trending-up fs-2 text-primary"></i>
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <div
                    className="p-3 rounded d-flex align-items-center justify-content-between"
                    style={{ background: "#ede7f6" }}
                  >
                    <div>
                      <h6 className="mb-1">Upcoming Approved Leaves</h6>
                      <h4 className="mb-0 text-primary">
                        {leave_Balance_data?.UpcomingApproved || 0} Days
                      </h4>
                    </div>
                    <i className="ti ti-checks fs-2 text-primary"></i>
                  </div>
                </div>
              </div>

              <h5 className="mb-3">Leave Summary</h5>
              <div className="table-responsive">
                {/* TABLE */}
                <table className="table table-bordered">
                  <thead>
                    <th></th>
                    <th
                      colSpan={2}
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        fontSize: "15px",
                        color: "#000",
                      }}
                    >
                      Carry Forward
                    </th>
                    <th colSpan={2}></th>
                    <th
                      colSpan={2}
                      style={{
                        textAlign: "center",
                        fontWeight: "600",
                        fontSize: "15px",
                        color: "#000",
                      }}
                    >
                      Entitlement
                    </th>
                    <th colSpan={4}></th>
                  </thead>
                  <thead>
                    <tr>
                      <th style={tableStyle}>Type</th>
                      <th style={tableStyle}>Lapse</th>
                      <th style={tableStyle}>Opening</th>
                      <th style={tableStyle}>Consumed</th>
                      <th style={tableStyle}>Balance</th>
                      <th style={tableStyle}>Annual</th>
                      <th style={tableStyle}>Prorata</th>
                      <th style={tableStyle}>Availed</th>
                      <th style={tableStyle}>Available</th>
                      <th style={tableStyle}>Apply Leaves</th>

                      {/* <th style={tableStyle}>Closing</th> */}
                      {/* <th style={tableStyle}>Applied</th> */}
                      {/* <th style={tableStyle}>View</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {leave_Balance_data?.data &&
                      transformLeaveData(leave_Balance_data.data)
                        .slice(0, 3)
                        .map((row, index) => (
                          <tr key={index}>
                            <td style={tableStyle}>{row.type}</td>

                            {/* Grouped by category with matching colors */}
                            <td
                              style={{
                                ...tableStyle,
                                backgroundColor: categoryColors.lapse,
                              }}
                            >
                              {row.lapse}
                            </td>
                            <td
                              style={{
                                ...tableStyle,
                                backgroundColor: categoryColors.consumed,
                              }}
                            >
                              {row.opening}
                            </td>
                            <td
                              style={{
                                ...tableStyle,
                                backgroundColor: categoryColors.consumed,
                              }}
                            >
                              {row.consumed}
                            </td>
                            <td
                              style={{
                                ...tableStyle,
                                backgroundColor: categoryColors.consumed,
                              }}
                            >
                              {row.balance}
                            </td>
                            <td
                              style={{
                                ...tableStyle,
                                backgroundColor: categoryColors.annual,
                              }}
                            >
                              {row.annual}
                            </td>
                            <td
                              style={{
                                ...tableStyle,
                                backgroundColor: categoryColors.prorata,
                              }}
                            >
                              {row.prorata}
                            </td>
                            <td
                              style={{
                                ...tableStyle,
                                backgroundColor: categoryColors.availed,
                              }}
                            >
                              {row.availed}
                            </td>
                            <td
                              style={{
                                ...tableStyle,
                                backgroundColor: categoryColors.available,
                              }}
                            >
                              {row.closing}
                            </td>
                            <td
                              style={{
                                ...tableStyle,
                                backgroundColor: categoryColors.available,
                              }}
                            >
                              <Link
                                to="/leave-application"
                                className="btn btn-sm btn-outline-primary"
                              >
                                Apply {row.type}
                              </Link>
                            </td>

                            {/* <td style={{ ...tableStyle, backgroundColor: categoryColors.closing, color: "white" }}>{row.closing}</td> */}
                            {/* <td style={{ ...tableStyle, backgroundColor: categoryColors.applied, color: "white" }}>{row.applied}</td> */}
                          </tr>
                        ))}
                  </tbody>
                </table>
                <div className="card mt-3">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="border rounded p-3 h-100">
                          <h6>Earned Leave</h6>
                          <p className="mb-1 small text-muted">
                            Accrued monthly | Can be carried forward
                          </p>
                          <Link to="/key-policy" className="text-primary small">
                            View Leave Policy
                          </Link>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="border rounded p-3 h-100">
                          <h6>Sick Leave</h6>
                          <p className="mb-1 small text-muted">
                            No carry forward | Medical proof may apply
                          </p>
                          <Link to="/key-policy" className="text-primary small">
                            View Leave Policy
                          </Link>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="border rounded p-3 h-100">
                          <h6>Restricted Holiday</h6>
                          <p className="mb-1 small text-muted">
                            Select from approved RH list
                          </p>
                          <Link to="/key-policy" className="text-primary small">
                            View Leave Policy
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="p-3 d-flex justify-content-end">
                    <button className="btn btn-outline-primary">
                      <i className="ti-arrow-down me-2"></i>{" "}
                    
                      Download Leave Statement | <i className="ti ti-file-spreadsheet" /> Excel 
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="card mt-3">
            <div className="card-body">
              {/* <h6 className="mb-2">
                <strong>Leave Types (From Balance Data)</strong>
              </h6> */}
              <div className="row">
                {leave_Balance_data?.data &&
                  transformLeaveData(leave_Balance_data.data)
                    .slice(0, 3)
                    .map((row, index) => (
                      <div className="col-md-4 mb-0" key={index}>
                        <div className="p-2">
                          <strong>{row.type}</strong>
                          {" – "}
                          {leaveTypeFullForms[row.type] || "Unknown Leave Type"}
                        </div>
                      </div>
                    ))}
              </div>
            </div>
          </div>
          {/* Footer */}
          <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
            <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveBalance;
